import { useEffect, useState } from 'react';

import { s } from './List.styles';
import { replace, useNavigate } from 'react-router-dom';
import { usePatternContext } from '../../../../context/PatternContext';
import { MyPatternListProps } from '../../../../interface/aiAnalyze/aiRecommend/type';
import PatternService from '../../../../service/Pattern';
import Loading from '../../../../func/components/loading/LoadingCircle';
// import SaveModal from '../../myAlgorithm/result/SaveModal';
import {
  MarketPriceEstimationData,
  AppraisalPointData,
  NumberOfFailedBidData,
  OldAgeData,
  SalesDaysData,
} from '../../../../interface/aiAnalyze/aiRecommend/data';
import Pagination from '../../../../func/components/pagination/Pagination';

interface Props {
  data: MyPatternListProps[];
  offset: number;
  setOffset: (offset: number) => void;
  totalCount: number;
  tab: string;
  loading: boolean;
  getList: (tab: string) => void;
}
const List = ({
  data,
  offset,
  setOffset,
  totalCount,
  tab,
  loading,
  getList,
}: Props) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState<number[]>([]);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const navigate = useNavigate();
  const { setPIdx } = usePatternContext();

  useEffect(() => {
    setTotalPages(Math.ceil(totalCount / 10));
  }, [totalCount]);

  useEffect(() => {
    if (offset === 0) {
      setCurrentPage(1);
    }
  }, [offset]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setOffset((page - 1) * 10);
  };

  const FormatTotalResultText = (grade: number) => {
    if (grade === 0) {
      return null;
    }
    if (grade === 1) {
      return <span style={{ color: '#F45551' }}>요주의</span>;
    } else if (grade === 2) {
      return <span style={{ color: '#09AB49' }}>보통</span>;
    } else if (grade === 3) {
      return <span style={{ color: '##008AFF' }}>우수</span>;
    } else {
      return <span style={{ color: '##008AFF' }}>매우우수</span>;
    }
  };

  const ChangeLabelToValue = (value: string, data: any) => {
    const newValue = data.find((item: any) => item.value === value)?.label;
    return newValue ? ', ' + newValue : '';
  };

  const changeCategory = (category: string) => {
    if (category === 'hug') {
      return 'HUG인수조건변경';
    }

    if (category === 'opposing_power') {
      return '임차인 대항력';
    }
    if (category === 'wage_bond') {
      return '임금채권';
    }
    if (category === 'resale') {
      return '재매각';
    }
    if (category === 'violation_building') {
      return '위반건축물';
    }
    if (category === 'statutory_superficies') {
      return '법정지상권';
    }
    if (category === 'tomb_base_right') {
      return '분묘기지권';
    }
    if (category === 'lien') {
      return '유치권';
    }
    return '';
  };

  const ChangeSpecialPatternText = (value: string, category: string) => {
    const Text = changeCategory(category);
    if (value === 'A') {
      return null;
    }
    if (value === 'Y') {
      return (
        <span>
          {`${Text}> 선택`}
          {category !== 'lien' && ', '}
        </span>
      );
    } else {
      return (
        <>
          <span>{`${Text}> `}</span>
          <span style={{ color: '#F45551' }}>제외</span>{' '}
          {category !== 'lien' && ', '}
        </>
      );
    }
  };

  const deletePattern = async (pIdx?: number) => {
    if (!window.confirm('정말로 삭제하시겠습니까?')) return;

    try {
      const data = pIdx ? { p_idx: [pIdx] } : { p_idx: selectedItem };
      const res = await PatternService.deleteMyPattern(data);
      alert('알고리즘 삭제가 완료되었습니다.');
      getList(tab);
    } catch (error) {
      console.log(error);
    }
  };

  const toggleSelectAll = () => {
    if (selectedItem.length === data.length) {
      setSelectedItem([]);
    } else {
      // 전체 선택되지 않음 -> 전체 선택
      setSelectedItem(data.map((item) => item.p_idx));
    }
  };

  return (
    <s.Container>
      <s.AllCheckBox>
        <img
          src={
            selectedItem.length > 0 && selectedItem.length === data.length
              ? '/assets/images/check/idSaveOn.svg'
              : '/assets/images/check/idSaveOff.svg'
          }
          alt="전체 선택"
          onClick={toggleSelectAll}
          style={{ cursor: 'pointer' }}
        />
        <s.Button
          onClick={() => {
            deletePattern();
          }}
          active={selectedItem.length > 0}
        >
          삭제
        </s.Button>
        {tab === 'B' && totalCount === 20 && (
          <span style={{ fontSize: 14, color: '#F45551' }}>
            *알고리즘 등록은 최대 20개까지 가능합니다
          </span>
        )}
      </s.AllCheckBox>
      <s.ListBox>
        <s.ListHeader>
          <s.ListHeaderItem style={{ width: '36px' }}></s.ListHeaderItem>
          <s.ListHeaderItem style={{ width: 'calc(50% - 18px)' }}>
            분석결과/알고리즘명
          </s.ListHeaderItem>
          <s.ListHeaderItem style={{ width: 'calc(50% - 18px)' }}>
            분석일자
          </s.ListHeaderItem>
        </s.ListHeader>{' '}
        <s.List>
          {loading && <Loading />}
          {!loading &&
            data.length > 0 &&
            data.map((item, idx) => (
              <s.ListRow2 key={idx}>
                <s.ListRow style={{ paddingBlock: '16px' }}>
                  <s.RowItem style={{ width: '36px' }}>
                    <img
                      src={
                        selectedItem.includes(item.p_idx)
                          ? '/assets/images/check/idSaveOn.svg'
                          : '/assets/images/check/idSaveOff.svg'
                      }
                      alt=""
                      onClick={() => {
                        if (selectedItem.includes(item.p_idx)) {
                          setSelectedItem(
                            selectedItem.filter((idx) => idx !== item.p_idx),
                          );
                        } else {
                          setSelectedItem([...selectedItem, item.p_idx]);
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </s.RowItem>
                  <s.RowItem style={{ gap: '10px', width: 'calc(50% - 18px)' }}>
                    {item.grade !== null && (
                      <s.Tag grade={Number(item.grade)}>
                        {FormatTotalResultText(Number(item.grade))}
                      </s.Tag>
                    )}
                    {item.title !== null && <span>{item.title}</span>}
                  </s.RowItem>

                  <s.RowItem style={{ width: 'calc(50% - 18px)' }}>
                    <s.DateBox>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                          alignItems: 'center',
                        }}
                      >
                        <s.ResultButton
                          onClick={() => {
                            navigate(`/patternResult/${item.p_idx}`);
                          }}
                        >
                          결과보기
                        </s.ResultButton>
                        {item.title === null && (
                          <s.SaveButton
                            onClick={() => {
                              setPIdx(item.p_idx);
                              setShowSaveModal(true);
                            }}
                          >
                            저장하기
                          </s.SaveButton>
                        )}
                        <span>
                          {item.create_time
                            ? item.create_time
                                .split(' ')[0]
                                .replace(/-/g, '.')
                                .slice(2)
                            : ''}
                        </span>
                      </div>
                      <div
                        style={{ padding: '9px', cursor: 'pointer' }}
                        onClick={() => {
                          deletePattern(item.p_idx);
                        }}
                      >
                        <img src="/assets/images/icon/trashcan.svg" alt="" />
                      </div>
                    </s.DateBox>
                  </s.RowItem>
                </s.ListRow>
                <s.ListRow>
                  <s.RowItem
                    style={{
                      gap: '8px',
                      justifyContent: 'flex-start',
                      padding: '24px 16px',
                      background: '#FAFAFB',
                    }}
                  >
                    <s.PatternBox>
                      <s.Number>1</s.Number>
                      분석기준
                    </s.PatternBox>
                    <s.Patterns>
                      {item.ctp}
                      {item.sig === null ? '' : `>${item.sig}`}
                      {item.emd === null ? '' : `>${item.emd}`},
                      {item.item_category + ', '}
                      {item.start_date.split('T')[0]}~
                      {item.end_date.split('T')[0]}
                      {item.zoning && `, ${item.zoning} `}
                    </s.Patterns>
                    <s.PatternBox>
                      <s.Number>2</s.Number>
                      핵심 알고리즘
                    </s.PatternBox>
                    <s.Patterns>
                      {item.margin !== 'A' && (
                        <span>
                          {item.margin === 'Y'
                            ? `차익有(낙찰가<매각가)`
                            : item.margin === 'N'
                              ? `차익無(낙찰가>매각가)`
                              : ''}
                          ,
                        </span>
                      )}
                      {item.hidden_value !== 'A' && (
                        <span>
                          {item.hidden_value === 'L'
                            ? `저평가 (시세>감정가)`
                            : item.hidden_value === 'H'
                              ? `고평가 (시세<감정가)`
                              : ''}
                          ,
                        </span>
                      )}
                      <span>
                        {item.profit === 'Y'
                          ? '부대비용 포함'
                          : '부대비용 미포함'}
                      </span>
                      <span>
                        {ChangeLabelToValue(
                          item.market_prc,
                          MarketPriceEstimationData,
                        )}
                      </span>
                      <span>
                        {ChangeLabelToValue(
                          item.appraisal_point,
                          AppraisalPointData,
                        )}
                      </span>
                      <span>
                        {ChangeLabelToValue(
                          item.bid_cnt,
                          NumberOfFailedBidData,
                        )}
                      </span>
                      <span>
                        {ChangeLabelToValue(item.elapsed_years, OldAgeData)}
                      </span>
                      <span>
                        {ChangeLabelToValue(item.sale_days, SalesDaysData)}
                      </span>
                      <span>
                        {item.investment_rate !== null &&
                          `낙찰가의 ${item.investment_rate}%`}
                      </span>
                    </s.Patterns>
                    <s.PatternBox>
                      <s.Number>3</s.Number>
                      특수 알고리즘
                    </s.PatternBox>
                    <s.Patterns>
                      {ChangeSpecialPatternText(item.hug, 'hug')}
                      {ChangeSpecialPatternText(
                        item.opposing_power,
                        'opposing_power',
                      )}
                      {ChangeSpecialPatternText(item.wage_bond, 'wage_bond')}
                      {ChangeSpecialPatternText(item.resale, 'resale')}
                      {ChangeSpecialPatternText(
                        item.violation_building,
                        'violation_building',
                      )}
                      {ChangeSpecialPatternText(
                        item.statutory_superficies,
                        'statutory_superficies',
                      )}
                      {ChangeSpecialPatternText(
                        item.tomb_base_right,
                        'tomb_base_right',
                      )}
                      {ChangeSpecialPatternText(item.lien, 'lien')}
                    </s.Patterns>
                  </s.RowItem>
                </s.ListRow>
              </s.ListRow2>
            ))}
        </s.List>
        {!loading && data.length === 0 && (
          <s.EmptyList>
            <span>
              {tab === 'B'
                ? '저장한 알고리즘이 없습니다.'
                : '최근 분석 알고리즘이 없습니다.'}
            </span>
            <s.PlusBox
              onClick={() => {
                navigate('/myAlgorithm');
              }}
            >
              <img src="/assets/images/plus/plus-gray.svg" alt="" />
              <span>
                {tab === 'B'
                  ? '알고리즘 추가하기'
                  : '나만의 AI 알고리즘 만들기'}
              </span>
            </s.PlusBox>
          </s.EmptyList>
        )}
      </s.ListBox>
      {!loading && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
      {/* {showSaveModal && (
        <SaveModal
          setShowSaveModal={setShowSaveModal}
          getList={getList}
          page="patternList"
        />
      )} */}
    </s.Container>
  );
};

export default List;
